/* tslint:disable */
/* eslint-disable */
/**
 * Eatgrim Shipping API
 * Eatgrim Shipping API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@soundsgood.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function AddressFromJSON(json) {
    return AddressFromJSONTyped(json, false);
}
export function AddressFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'address1': json['address1'],
        'address2': !exists(json, 'address2') ? undefined : json['address2'],
        'company': !exists(json, 'company') ? undefined : json['company'],
        'city': json['city'],
        'zipCode': !exists(json, 'zipCode') ? undefined : json['zipCode'],
        'country': json['country'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
    };
}
export function AddressToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'firstName': value.firstName,
        'lastName': value.lastName,
        'address1': value.address1,
        'address2': value.address2,
        'company': value.company,
        'city': value.city,
        'zipCode': value.zipCode,
        'country': value.country,
        'phone': value.phone,
    };
}
